import { captureScreenshot, getFormLettersForDomain, saveFormLetterTemplate, deactivateFormLetterTemplate } from '@/libraries/api/viewerTools'
import { owalDefault } from '@/libraries/util/detectionForms.js'

export const ViewerToolsModule = {
  namespaced: true,
  state: {
    capturedImages: [],
    formLetters: {},
    isInvestigating: false,
    editorCommand: undefined,
    snapshotMetadata: {
      location: undefined,
      timestamp: undefined,
    },
  },
  mutations: {
    setIsInvestigating (state, value) {
      state.isInvestigating = value
    },
    setFormLetters (state, formLetters) {
      state.formLetters = formLetters
    },
    addCapturedImage (state, imageData) {
      state.capturedImages.push(imageData)
    },
    setEditorCommand (state, command) {
      state.editorCommand = command
    },
    setSnapshotMetadata (state, payload) {
      state.snapshotMetadata.location = payload.location
      state.snapshotMetadata.timestamp = payload.timestamp
    },
    clearCapturedImages (state) {
      state.capturedImages = []
    },
    addFormLetter (state, formLetter) {
      let form = {}
      form[formLetter.id] = formLetter
      const formLetters = Object.assign({}, state.formLetters, form)
      state.formLetters = formLetters
    },
    removeFormLetter (state, id) {
      const formLetters = Object.assign({}, state.formLetters)
      delete formLetters[id]
      state.formLetters = formLetters
    },
  },
  getters: {
    isInvestigating (state) {
      return state.isInvestigating
    },
    formTypes (state) {
      const types = Object.keys(state.formLetters).map(key => {
        return state.formLetters[key].description
      })

      return types
    },
    formLetters (state) {
      const userForms = Object.values(state.formLetters)

      return userForms
    },
    editorCommand (state) {
      return state.editorCommand
    },
    capturedImages (state) {
      return state.capturedImages
    },
  },
  actions: {
    captureScreenshot ({ state, commit, rootState }, payload) {
      captureScreenshot(payload.cameraUUID, payload.timestamp).then(function (res) {
        if (res.data) {
          let image = btoa(
            new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
          )
          const titleString = `${state.snapshotMetadata.location} ${state.snapshotMetadata.timestamp}`
          const imageObject = {
            src: `data:${res.headers['content-type']};base64,${image}`,
            alt: titleString,
            title: titleString,
          }
          commit('addCapturedImage', imageObject)
        }
      }).catch(error => {
        alert(`Error! ${error}`)
      })
    },
    getFormLettersForDomain ({ state, commit, rootState }) {
      const currentDomainUUID = rootState.data.domains.current.uuid
      getFormLettersForDomain(currentDomainUUID).then(function (response) {
        const mappedForms = response.data.forms.reduce((formObject, currentForm) => {
          formObject[currentForm.id] = currentForm
          return formObject
        }, {})
        mappedForms[owalDefault.id] = owalDefault
        commit('setFormLetters', mappedForms)
      })
    },
    saveFormLetterTemplate ({ state, commit, rootState }, payload) {
      saveFormLetterTemplate(payload).then(res => {
        commit('addFormLetter', res.data.form_letter)
        if (res.data.deactivated) {
          commit('removeFormLetter', res.data.deactivated)
        }
      })
    },
    deactivateFormLetterTemplate ({ state, commit, rootState }, formLetterID) {
      const currentDomainUUID = rootState.data.domains.current.uuid
      commit('removeFormLetter', formLetterID)
      deactivateFormLetterTemplate(formLetterID, currentDomainUUID)
    },
  },
}
